import React, { useEffect, useState, useCallback } from 'react';

import { Redirect } from 'react-router-dom';

import AddProfile from './AddProfile';

import { isV2PermissionsEnabled } from '../../helpers/featureFlags/isV2PermissionsEnabled';
import { useHasAnyRole, ROLE } from '../../utils/permissions';
import Layout from '../Layout/ProviderLayout';

const ProviderProfile = () => {
  let userHasAccess = false;

  const { hasRoles } = useHasAnyRole([ROLE.ADMIN, ROLE.BASIC_PROVIDER, ROLE.ADVANCED_PROVIDER]);

  if (isV2PermissionsEnabled()) {
    userHasAccess = hasRoles;
  }

  return !userHasAccess && isV2PermissionsEnabled() ? (
    <Redirect to="/locations/place/-78.549668/39.014/7" />
  ) : (
    <Layout>
      <div className="pageContainer">
        <AddProfile />
      </div>
    </Layout>
  );
};

export default ProviderProfile;
